import * as z from "zod/v4";

export const setPublishedAutomations = {
  name: "setPublishedAutomations" as const,
  input: z.object({ ruleIds: z.array(z.string()) }),
  output: z.object({ success: z.boolean() }),
};
